<template>
  <v-container fluid class="gl-post-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex flex-start justify-md-start">
              <v-btn @click="newGLPostDialog" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" @click="isFindPost=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn @click="refreshPosts" color="primary" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-refresh</v-icon>
                Refresh
              </v-btn>
              <v-btn to="/gl-report/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Reports
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="gl-posts-table"
              show-select
              single-select
              item-key="_id"
              sort-by="post"
              :footer-props="footer"
              :headers="header_posts"
              :items="data_posts"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeletePost"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Post?
                    </v-card-title>

                    <v-card-text>
                      {{ delete_post.postname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeletePost = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deletePost(delete_post)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.postname="{ item }">
                <p class="two-line" v-if="item.posttype!=null">{{ item.posttype }}</p>
                <p class="two-line" v-if="item.postname!=null">{{ item.postname }}</p>
                <p class="two-line" v-if="item.currencyRate!=null">Rate: {{ item.currencyRate }}</p>
              </template>
              <template v-slot:item.poststatus="{ item }">
                <v-chip
                  :color="getStatusColor(item.poststatus)"
                  small>
                  {{ item.poststatus }}
                </v-chip>
              </template>
              <template v-slot:item.isSalesOrders="{ item }">
                <v-icon v-if="item.isSalesOrders==true" size="18" color="blue">mdi-check</v-icon>
                <v-icon v-if="item.isSalesInvoices==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.isInventoryJournals="{ item }">
                <v-icon v-if="item.isInventoryJournals==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.isPurchaseOrders="{ item }">
                <v-icon v-if="item.isPurchaseOrders==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.isInvoices="{ item }">
                <v-icon v-if="item.isInvoices==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.isBills="{ item }">
                <v-icon v-if="item.isBills==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.isDeposits="{ item }">
                <v-icon v-if="item.isBatchDeposits==true" size="18" color="blue">mdi-check</v-icon>
                <v-icon v-if="item.isDeposits==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.isPayments="{ item }">
                <v-icon v-if="item.isBatchPayments==true" size="18" color="blue">mdi-check</v-icon>
                <v-icon v-if="item.isPayments==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.isPayroll="{ item }">
                <v-icon v-if="item.isPayroll==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.isReimbursements="{ item }">
                <v-icon v-if="item.isReimbursements==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.isFABills="{ item }">
                <v-icon v-if="item.isFABills==true" size="18" color="blue">mdi-check</v-icon>
                <v-icon v-if="item.isFADepreciations==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-text-box-search</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn v-if="item.poststatus=='New'" icon color="primary" @click="updatePostSendDialog(item)">
                  <v-icon>mdi-text-box-edit</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deletePostDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div>
      <v-dialog
        v-model="isNewPost"
        persistent
        width="600px"
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Post Month</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="glledgers.map(x => {
                      return {text: x.ledgername, value: x._id};
                    })"
                    v-model="new_post.ledgerid"
                    v-on:change="onChangeLedger($event)"
                    v-bind:error="errorindex == 0"
                    dense
                    placeholder="Ledger"
                    persistent-hint
                    single-line hint="Ledger"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="menu_postdate"
                    v-model="menu_postdate"
                    :close-on-content-click="false"
                    :return-value.sync="new_post.postdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="new_post.postdate"
                        label="Post Date"
                        v-bind="attrs"
                        v-bind:value="new_post.postdate"
                        v-bind:error="errorindex == 1"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please choose the post date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="new_post.postdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_postdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_postdate.save(new_post.postdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="menu_poststartdate"
                    v-model="menu_poststartdate"
                    :close-on-content-click="false"
                    :return-value.sync="new_post.poststartdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="new_post.poststartdate"
                        v-on:change="onChangeStartDate($event)"
                        label="Start Date"
                        v-bind="attrs"
                        v-bind:value="new_post.poststartdate"
                        v-bind:error="errorindex == 2"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please choose the start date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="new_post.poststartdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_poststartdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="onChangeStartDate(new_post.poststartdate); $refs.menu_poststartdate.save(new_post.poststartdate);"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    dense
                    readonly
                    v-model="new_post.postenddate"
                    label="End Date"
                    v-bind:value="new_post.postenddate"
                    persistent-hint
                    single-line hint="Please choose the end date">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    dense
                    readonly
                    v-model="new_post.primaryCurrency"
                    label="Currency 1"
                    v-bind:value="new_post.primaryCurrency"
                    persistent-hint
                    single-line hint="Primary currency">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    dense
                    readonly
                    v-model="new_post.secondaryCurrency"
                    label="Currency 2"
                    v-bind:value="new_post.secondaryCurrency"
                    persistent-hint
                    single-line hint="Secondary currency">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    dense
                    type="number"
                    v-model="new_post.currencyRate"
                    v-bind:error="errorindex == 3"
                    label="Currency Rate"
                    v-bind:value="new_post.currencyRate"
                    persistent-hint
                    single-line 
                    :hint="`${new_post.secondaryCurrency}/${new_post.primaryCurrency} Rate`">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isNewPost = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="newGLPost"
              >
                Save
              </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
            <v-dialog
        v-model="isFindPost"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Posts</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_startdate"
                    v-model="menu_startdate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.startdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="find_query.startdate"
                        label="Start Date"
                        v-bind="attrs"
                        v-bind:value="find_query.startdate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter start date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.startdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_startdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_startdate.save(find_query.startdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_enddate"
                    v-model="menu_enddate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="find_query.enddate"
                        label="End Date"
                        v-bind="attrs"
                        v-bind:value="find_query.enddate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter end date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.enddate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_enddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_enddate.save(find_query.enddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindPost = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetPosts"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findPosts"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isPostSend"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Send GL Post</span>
            </v-card-title>
            <v-card-text>
              {{ post_send.postname }}
            </v-card-text>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="post_send.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Send'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isPostSend=false; post_send={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="post_send.confirm!=='Send'"
                @click="updatePostSend"
              >
                Send
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from '@/util/tools';
import { getFirstDay, getLastDay } from "../../../util/tools";

export default {
  name: 'GLPostList',
  data() {
    return {
      config,
      menu_postdate: null,
      menu_poststartdate: null,
      menu_startdate: null,
      menu_enddate: null,
      isFindPost: false,
      isDeletePost: false,
      isPostSend: false,
      isNewPost: false,
      delete_post: {},
      new_post: {},
      post_send: {},
      find_query: {},
      header_posts: [
        { text: 'Name', value: 'postname' },        
        { text: 'SO', value: 'isSalesOrders', width: "2%" },
        { text: 'DO', value: 'isDeliveryOrders', width: "2%" },
        { text: 'PO', value: 'isPurchaseOrders', width: "2%" },
        { text: 'INV', value: 'isInvoices', width: "2%" },
        { text: 'BIL', value: 'isBills', width: "2%" },
        { text: 'DEP', value: 'isDeposits', width: "2%" },
        { text: 'PAY', value: 'isPayments', width: "2%" },
        { text: 'PYR', value: 'isPayroll', width: "2%" },
        { text: 'RMB', value: 'isReimbursements', width: "2%" },
        { text: 'IVT', value: 'isInventoryJournals', width: "2%" },
        { text: 'AST', value: 'isFABills', width: "2%" },
        { text: 'Status', value: 'poststatus', width: "5%"  },
        { text: 'Actions', value: 'actions', sortable: false, width: "8%" },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      data_posts: [],
      errorindex: null,
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('GLLedger', ['glledgers']),
    ...mapState('GLPost', ['glposts', 'query', 'isReceiving', 'isDeleting', 'glpostsMessage', 'isUpdating']),
  },
  methods: {
    ...mapActions('GLLedger', ["getGLLedgersRequest"]),
    ...mapActions('GLPost', ["getGLPostsRequest","findGLPostsRequest", "deleteGLPostRequest","updateGLPostRequest","updateGLPostSendRequest","insertGLPostRequest"]),
    checkError(){
      if(!this.new_post.ledgerid){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_post.postdate){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_post.poststartdate){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.new_post.currencyRate){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    viewItem(item) {
      this.$router.push({ name: 'GLPostView', params: item })
    },
    editItem(item) {
      this.$router.push({ name: 'GLPostEdit', params: item });
    },
    async deletePost(item) {
      this.isDeletePost = false;
      let result = await this.deleteGLPostRequest(item);
      let index = this.data_posts.findIndex(i=>i._id==result._id);
      this.data_posts.splice(index, 1);
    },
    deletePostDialog(item) {
      this.isDeletePost = true;
      this.delete_post = { _id: item._id, postname: item.postname };
    },
    async findPosts(){
      this.isFindPost = false;
      if(Object.keys(this.find_query).length==0){
        await this.getGLPostsRequest();
        this.data_posts = Object.assign([], this.glposts);
      }
      else{
        let result = await this.findGLPostsRequest(this.find_query);
        this.data_posts = Object.assign([], result);
      }
    },
    async resetPosts(){
      this.find_query = {};
    },
    async refreshPosts() {
      if(Object.keys(this.query).length==0){
        await this.getGLPostsRequest();
        this.data_posts = Object.assign([], this.glposts);
      }
      else {
        this.find_query = Object.assign({}, this.query);
        let result = await this.findGLPostsRequest(this.find_query);
        this.data_posts = Object.assign([], result);
      }
    },
    newGLPostDialog() {
      this.new_post = {}
      this.isNewPost = true;
    },
    async newGLPost(){
      if(!this.checkError()) return;
      let result = await this.insertGLPostRequest(this.new_post);
      console.log(result);
      this.data_posts = [result, ...this.data_posts];
      this.isNewPost = false;
    },
    updatePostSendDialog(item) {
      this.isPostSend = true;
      this.post_send = { _id: item._id, postname: item.postname };
    },
    async updatePostSend() {
      this.isPostSend = false;
      let result = await this.updateGLPostSendRequest(this.post_send);
      let index = this.data_posts.findIndex(x=>x._id==result._id);
      this.data_posts.splice(index, 1, result);
      this.post_send = {};
    },
    onChangeStartDate(value) {
      let date = new Date(value);
      let start_date = getFirstDay(date);
      let end_date = getLastDay(date);
      this.new_post = Object.assign({}, this.new_post, {poststartdate: start_date, postenddate: end_date});
    },
    onChangeLedger(id) {
      let ledger = this.glledgers.find(ledger=>ledger._id==id);
      if(ledger==null) return;
      this.new_post = Object.assign({}, this.new_post, {primaryCurrency: ledger.primaryCurrency, secondaryCurrency: ledger.secondaryCurrency});
    },
  },
  async created () {
    if(Object.keys(this.query).length==0){
      await this.getGLPostsRequest();
      this.data_posts = Object.assign([], this.glposts);
    }
    else {
      this.find_query = Object.assign({}, this.query);
      let result = await this.findGLPostsRequest(this.find_query);
      this.data_posts = Object.assign([], result);
    }

    if(this.glledgers.length==0) await this.getGLLedgersRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
